import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/apis";
import { sagaFunctions } from "../../config/helper";
import {
  CustomerActivate,
  ForgotPassoword,
  NewPassoword,
  Register,
  ResetPassoword,
  Logout,
  Sessions
} from "./Action";

function register(req) {
  return sagaFunctions(Register, "post", apis.register, req.payload)();
}

function customer_activate(req) {
  return sagaFunctions(
    CustomerActivate,
    "post",
    apis.admin.customer_enable+"?admin=true",
    req.payload
  )();
}

function sessions(req) {
  return sagaFunctions(Sessions, "post", apis.sessions, req.payload)();
}

function logout(req){
  return sagaFunctions(Logout, "get", apis.logout, req.payload)();
}

function new_password(req) {
  return sagaFunctions(NewPassoword, "post", apis.new_password, req.payload)();
}

function forgot_password(req) {
  return sagaFunctions(
    ForgotPassoword,
    "get",
    apis.forgot_password,
    req.payload
  )();
}

function reset_password(req) {
  return sagaFunctions(
    ResetPassoword,
    "post",
    apis.reset_password,
    req.payload
  )();
}

export function* registerWatcher() {
  yield takeLatest(Register.REQUEST, register);
  yield takeLatest(Sessions.REQUEST, sessions);
  yield takeLatest(NewPassoword.REQUEST, new_password);
  yield takeLatest(ForgotPassoword.REQUEST, forgot_password);
  yield takeLatest(ResetPassoword.REQUEST, reset_password);
  yield takeLatest(CustomerActivate.REQUEST, customer_activate);
  yield takeLatest(Logout.REQUEST, logout);
}
